import {WlTextInput} from "../../../webcomponents/textInput/textInput.component";
import {SimpleInputErrorManager} from "./SimpleInputErrorManager";

export class WlTextInputErrorManager implements SimpleInputErrorManager {
    private readonly element: WlTextInput;

    constructor(element: WlTextInput) {
        this.element = element;
    }

    manageError(isValid: boolean) {
        if (isValid) {
            this.element.setValid();
        } else {
            this.element.setInvalid();
        }
    }
}
